<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managerole/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
